/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 4C8.635 4 6 6.572 6 9.632v1H4v-1C4 5.367 7.633 2 12 2s8 3.367 8 7.632c0 3.164-2.093 5.525-3.77 7.315-.276.294-.53.693-.844 1.216l-.103.173c-.273.457-.59.987-.963 1.476C13.43 20.977 12.146 22 10 22a6.162 6.162 0 0 1-3.58-1.133l-.815-.58 1.16-1.629.814.58A4.162 4.162 0 0 0 10 20c1.354 0 2.104-.581 2.73-1.402.3-.392.555-.82.835-1.288l.106-.176c.305-.508.658-1.084 1.1-1.555C16.5 13.732 18 11.91 18 9.632 18 6.572 15.365 4 12 4z" />
        <path d="M12 8c-1.06 0-2 .916-2 2.15V11h1.65c1.394 0 2.35 1.221 2.35 2.5s-.956 2.5-2.35 2.5H11v-2h.65c.06 0 .136-.025.211-.108.077-.085.139-.221.139-.392s-.062-.307-.139-.392c-.075-.083-.15-.108-.211-.108H10v1H8v-3.85C8 7.905 9.745 6 12 6s4 1.905 4 4.15h-2C14 8.916 13.06 8 12 8z" />
      </g>
    </g>
  </Icon>
);
export { SvgEar as Ear };
